import RouteNames from '../../../../../../app/router/_internals/RouteNames.enum.js';

export default Object.freeze({
	GENERAL: `${RouteNames.TRIGGERS}-general`,
	VARIABLES: `${RouteNames.TRIGGERS}-variables`,
	RUNNING_HISTORY: `${RouteNames.TRIGGERS}-running-history`,
});
